import {INTEGRATION_NAME_APPROXIMATION_EQUALS} from 'utils/integrations/const';

/**
 * Return the display name of an integration in the UI
 * @param integration {Object} integration object with the field `.name`
 * @return {string} displayName
 */
export default function displayNameForIntegration(integration) {
  INTEGRATION_NAME_APPROXIMATION_EQUALS.forEach(names => {
    if (names.contains(integration.name)) {
      return names.first();
    }
  });
  return integration.name;
}
